import { SubmitButton } from 'components/common/buttons/SubmitButton';
import React, { useEffect, useMemo, useState } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { fetchInterpreters } from 'slices/interpreterSlice';
import { selectCustomStyles } from './Select';
import { AsyncPaginate } from 'react-select-async-paginate';
import { fetchVendors } from 'slices/vendorSlice';
import { CheckinCheckout } from 'components/ScheduleForm';
import { CheckinDateTimeInputs } from 'components/ScheduleForm';
import { CheckoutDateTimeInputs } from 'components/ScheduleForm';
import { CommentsAndNotes } from 'components/ScheduleForm';
import { CustomSwitch } from './Switch';
import ErrorMessage from './ErrorMessage';
import { interpreterName } from 'helpers/interpreterName';

function TravelFeeModal({
    isOpen,
    onClose,
    onConfirm,
    item,
    loader,
    appointmentId,
}) {

    const dispatch = useDispatch();
    const methods = useForm();
    const { setFocus, handleSubmit, watch, formState: { errors }, control, setValue, setError: setErrors, clearErrors } = methods



    useEffect(() => {

        methods.reset({ travel_fee_amount: '' })

    }, [isOpen])

    useEffect(() => {
        setValue("travel_fee_amount", item?.appointment_details?.travel_fee_amount || "");
        setValue("travel_approved", item?.appointment_details?.travel_approved || 0);
    }, [item, isOpen])

    const isVendor = useMemo(() => {
        return watch('vendor_id') ? true : false
    }, [watch('vendor_id'),isOpen])

    const isInterpreter = useMemo(() => {
        return watch('interpreter_id') ? true : false
    }, [watch('interpreter_id'),isOpen])

    // #region vendordropdown 
    const [filterVendor, setFilterVendors] = useState({
        label: "",
        value: ""
    })

    useEffect(() => {
        if (item?.vendor?.name && item?.vendor?.id) {
            setFilterVendors({
                label: item?.vendor?.name || "",
                value: item?.vendor?.id || ""
            })
        } else {
            setFilterVendors(null)
        }
    }, [item?.vendor])

    const filteredVendorLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchVendors(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        return {
            options: result.data.map(val => ({
                value: val.id,
                label: val.name,
            })),

            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };
    //#endregion

    // #region Interpreter Dropdown 
    const [filterInterpreters, setFilterInterpreters] = useState({
        label: "",
        value: ""
    })

    useEffect(() => {
        // gate on id only — imported interpreters can have an empty first_name
        if (item?.interpreter?.id) {
            setFilterInterpreters({
                label: interpreterName(item?.interpreter),
                value: item?.interpreter?.id || ""
            })
        } else {
            setFilterInterpreters(null)
        }
    }, [item?.interpreter])

    const filteredInterpretersLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchInterpreters(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue, language_id:item?.language_id , appointmentDate : item?.date }, true, true));
        return {
            options: result.data.map(val => ({
                value: val.id,
                label: interpreterName(val),
            })),

            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };
    //#endregion


    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <FormProvider {...methods}>
                    <form action="" onSubmit={handleSubmit((data) => onConfirm(data, "travelFee"))}>
                        <ModalHeader className='header_modal align-items-center'>
                            <h5 className="modal-title_u">Travel Fee</h5>
                        </ModalHeader>
                        <ModalBody className='modal_form_body'>
                            <div className='step_cards step_1'>
                                <h2>Travel Fee</h2>

                                <div className="row-primary">
                                    <h2>Travel Fee Amount</h2>
                                    <div className='w-100'>
                                        <Controller
                                        name="travel_fee_amount"
                                        control={control}
                                        render={({ field }) => (
                                            <input
                                            className="input-in type_inp"
                                            type="number"
                                            name="travel_fee_amount"
                                            placeholder="Travel Fee Amount"
                                            {...field}
                                            onChange={(e) => {
                                                if (e.target.value.length <= 20) {
                                                field.onChange(e);
                                                }
                                            }}
                                            />
                                        )}
                                        />
                                        {errors?.travel_fee_amount?.message && (
                                            <ErrorMessage
                                                text={errors?.travel_fee_amount?.message}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="row-primary">
                                    <h2>Travel Approved</h2>
                                    <div className='w-100' style={{display:"flex",alignItems:"end"}}>
                                       <Controller
                                        name="travel_approved"
                                        control={control}
                                        required
                                        render={({ field }) => (
                                            <CustomSwitch
                                            labelText="active"
                                            checked={field.value == 1 ? true : false}
                                            handleChange={(checked) => field.onChange(checked ? 1 : 0)}
                                            />
                                        )}
                                        />
                                    </div>
                                </div>
                                {/* {
                                    watch("interpreter_id") &&
                                    <CheckinCheckout apptAssign={item?.appointment_assign} />
                                } */}
                                {/* {
                                    ((watch("available_status") && watch("interpreter_id") && item?.appointment_assign?.interpreter_id)) && (
                                        <>
                                            <CheckinDateTimeInputs />
                                            <CheckoutDateTimeInputs />
                                            <CommentsAndNotes />
                                        </>
                                    )
                                } */}
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <SubmitButton btnText="Submit" />
                            <button className="table_delete" type='button' onClick={onClose}>Cancel</button>
                        </ModalFooter>
                    </form>
                </FormProvider>
            </Modal>
        </>
    );
}

export default TravelFeeModal;